import { createActionGroup, emptyProps, props } from "@ngrx/store";
import {
    BackendBillInfo,
  Bill,
  BillExtraction,
  BillFilters,
  UploadedBill,
  ViewedBill,
} from "../../models/bill.model";
import { BillUserError } from "../../models/errors.model";

export const billActions = createActionGroup({
  source: "Bill",
  events: {
    "Load Bills": props<{ data: BillFilters | Object }>(),
    "Load Bills Success": props<{ payload: Bill[] }>(),
    "Load Bills Fail": emptyProps(),
    "Clear Bills": emptyProps(),

    "Download Bills": props<{ data: number[] }>(),
    "Download Bills Success": props<{ payload: string[] }>(),
    "Clear Download Bills": emptyProps(),

    "Get CSV": props<{ data: number[] }>(),
    "Get CSV Success": props<{ payload: string }>(),
    "Clear CSV": emptyProps(),

    "Get Excel": props<{ data: number[] }>(),
    "Get Excel Success": props<{ payload: Blob }>(),
    "Clear Excel": emptyProps(),

    "Get Presigned Url": props<{ filename: string }>(),
    "Get Presigned Url Success": props<{ payload: string }>(),
    "Get Presigned Url Fail": emptyProps(),

    // 'Upload Bills': props<{data: FormData, userId: number|null}>(),
    "Upload Bills S3": props<{ data: File; url: string }>(),
    "Upload Bills S3 Success": emptyProps(),
    "Upload Bills S3 Fail": emptyProps(),

    "Upload Bills Backend": props<{ data: BackendBillInfo[], userId: number, file_type: 'pdf'|'img', timestamp: string }>(),
    "Upload Bills Backend Success": props<{ payload: UploadedBill[] }>(),
    "Upload Bills Backend Fail": emptyProps(),
    "Clear Upload Bills Backend": emptyProps(),


    "View Bill": props<{ data: number }>(),
    "View Bill Success": props<{ payload: ViewedBill }>(),
    "Clear Viewed Bill": emptyProps(),

    "Extract Bills": props<{ data: number[] }>(),
    "Extract Bills Success": props<{ payload: BillUserError }>(),
    "Extract Bills Fail": emptyProps(),
    "Clear Extract Bills": emptyProps(),

    "Delete Bill Extraction": props<{ data: number[] }>(),

    "Add Bill": props<{ data: Bill[] }>(),
    "Add Bill Success": props<{ payload: Bill[] }>(),

    "Edit Bill Extraction": props<{ data: ViewedBill }>(),
    "Edit Bill Extraction Success": props<{ payload: ViewedBill }>(),

    "Delete Bill": props<{ data: number[] }>(),
    "Delete Bill Success": props<{ payload: number[] }>(),

    "Set Bill Type": props<{ billId: number; billType: string }>(),
  },
});
